// extracted by mini-css-extract-plugin
module.exports = {"sideMenuWrapper":"sideMenu-module--sideMenuWrapper--w7Do7","menuHeader":"sideMenu-module--menuHeader--39_zG","openSideMenuWrapper":"sideMenu-module--openSideMenuWrapper--1nynU"};